import { render, staticRenderFns } from "./WithdrawDefaultForm.vue?vue&type=template&id=5ba5c04c&scoped=true"
import script from "./WithdrawDefaultForm.vue?vue&type=script&lang=js"
export * from "./WithdrawDefaultForm.vue?vue&type=script&lang=js"
import style0 from "./WithdrawDefaultForm.vue?vue&type=style&index=0&id=5ba5c04c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba5c04c",
  null
  
)

export default component.exports